import storage from '../storage'

const solutions = window.config ? window.config.solutions : []

export function getAppId() {
  let _id = 1
  let _solution = storage.local.getItem('auth/solution') || 1

  solutions.forEach(item => {
    if (parseInt(item.id) === parseInt(_solution)) {
      _id = item.appId
    }
  })
  return _id
}
